var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-check',{staticClass:"p-switch",model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._v("Afficher les biens vendus")])}
var staticRenderFns = []

export { render, staticRenderFns }